<template>
  <el-dialog
    :title="$t('shopServiceRule.editServiceRule')"
    :visible.sync="dialogVisible"
    width="600px"
    @close="clearForm"
  >
    <el-form ref="form" :model="form" :rules="rules" label-width="120px" label-position="left">
      <el-form-item :label="$t('shopServiceRule.typeName')" prop="typeName">
        <el-input
          v-model="form.typeName"
          :placeholder="$t('shopServiceRule.inputTypeName')"
          disabled
          style="width: 100%"
        />
      </el-form-item>

      <el-form-item
        :label="$t('shopServiceRule.communityFee')"
        prop="communityFee"
      >
        <el-input
          v-model="form.communityFee"
          :placeholder="$t('shopServiceRule.inputCommunityFee')"
          style="width: 100%"
          @input="calculateServiceFee"
        >
          <template slot="append">%</template>
        </el-input>
      </el-form-item>

      <el-form-item
        :label="$t('shopServiceRule.profitFee')"
        prop="profitFee"
      >
        <el-input
          v-model="form.profitFee"
          :placeholder="$t('shopServiceRule.inputProfitFee')"
          style="width: 100%"
          @input="calculateServiceFee"
        >
          <template slot="append">%</template>
        </el-input>
      </el-form-item>

      <el-form-item
        :label="$t('shopServiceRule.serviceFee')"
        prop="serviceFee"
      >
        <el-input
          v-model="form.serviceFee"
          disabled
          style="width: 100%"
        >
          <template slot="append">%</template>
        </el-input>
      </el-form-item>

      <el-form-item
        :label="$t('shopServiceRule.remark')"
        prop="remark"
      >
        <el-input
          v-model="form.remark"
          type="textarea"
          :rows="3"
          :placeholder="$t('shopServiceRule.inputRemark')"
          style="width: 100%"
        />
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{ $t('common.cancel') }}</el-button>
      <el-button type="primary" @click="updateServiceRuleInfo">{{ $t('common.confirm') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { updateShopServiceRule } from '@/api/shop/shopServiceRuleApi'

export default {
  name: 'EditServiceRule',
  data() {
    const validateDecimal = (rule, value, callback) => {
      if (!value) {
        callback(new Error(this.$t('shopServiceRule.feeRequired')))
        return
      }
      const decimalRegex = /^\d+(\.\d{1,4})?$/
      if (!decimalRegex.test(value)) {
        callback(new Error(this.$t('shopServiceRule.feeFormatError')))
        return
      }
      const numValue = parseFloat(value)
      if (numValue < 0 || numValue > 100) {
        callback(new Error(this.$t('shopServiceRule.feeRangeError')))
        return
      }
      callback()
    }

    return {
      dialogVisible: false,
      form: {
        ssrId: '',
        shopTypeId: '',
        typeName: '',
        communityFee: '',
        profitFee: '',
        serviceFee: '0.0000',
        remark: ''
      },
      rules: {
        communityFee: [
          { required: true, validator: validateDecimal, trigger: 'blur' }
        ],
        profitFee: [
          { required: true, validator: validateDecimal, trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    open(data) {
      this.resetForm()
      this.form = {
        ssrId: data.ssrId,
        shopTypeId: data.shopTypeId,
        typeName: data.typeName,
        communityFee: data.communityFee || '',
        profitFee: data.profitFee || '',
        serviceFee: data.serviceFee || '0.0000',
        remark: data.remark || ''
      }
      this.dialogVisible = true
    },
    clearForm() {
      this.resetForm()
      if (this.$refs.form) {
        this.$refs.form.clearValidate()
      }
    },
    resetForm() {
      this.form = {
        ssrId: '',
        shopTypeId: '',
        typeName: '',
        communityFee: '',
        profitFee: '',
        serviceFee: '0.0000',
        remark: ''
      }
    },
    calculateServiceFee() {
      const communityFee = parseFloat(this.form.communityFee) || 0
      const profitFee = parseFloat(this.form.profitFee) || 0
      this.form.serviceFee = (communityFee + profitFee).toFixed(4)
    },
    async updateServiceRuleInfo() {
      this.$refs.form.validate(async (valid) => {
        if (!valid) {
          return false
        }

        try {
          const res = await updateShopServiceRule(this.form)
          if (res.code === 0) {
            this.$message.success(this.$t('common.saveSuccess'))
            this.dialogVisible = false
            this.$emit('refresh')
          } else {
            this.$message.error(res.msg || this.$t('common.saveFailed'))
          }
        } catch (error) {
          console.error('更新失败:', error)
          this.$message.error(this.$t('common.saveFailed'))
        }
      })
    }
  }
}
</script>

<style scoped>
</style>
